module.exports = __webpack_public_path__ + "12e050a2ab4f503c783c42abc260d69d.png";